module.exports = __webpack_public_path__ + "b25236e0e0b9fe8550f377491fa9557d.MP3";